import { getStatsigEnvTier } from '../session/session'
import { ENVIRONMENT, postToStatsig, USER_ID } from './statsig-client'

export const initialize = () => {
  const env = getStatsigEnvTier()

  const payload = {
    user: {
      userID: USER_ID,
      statsigEnvironment: ENVIRONMENT[env],
    },
    deltasResponseRequested: false,
    hash: 'djb2',
  }

  return postToStatsig('/v1/initialize', payload)
}
